module.exports = {
  DragDrop: {
    PluginName: "Sürükle Bırak",
    content_box_name: "İçerik ",
    Statement: "Doğru cevabı boş alana sürükleyip bırakın",
    Question: "Soru",
    Feedback: "Geri Bildirim",
    FeedbackMsg:
      "Cevap hakkında bir geri dönüş yazabilirsiniz. Bu özelliği araç çubuğundan kapatabilirsiniz.",
    TrueFeedbackMsg:
      "Doğru cevap hakkında bir geri dönüş yazabilirsiniz. Bu özelliği araç çubuğundan kapatabilirsiniz.",
    FalseFeedbackMsg:
      "Yanlış cevap hakkında bir geri dönüş yazabilirsiniz. Bu özelliği araç çubuğundan kapatabilirsiniz.",
    ShowFeedback: "Geri bildirim mesajı göster",
    Number: "Cevap sayısı",
    ShowLettersInsteadOfNumbers: "Sayılar yerine harfleri göster",
    background_color: "Arka Plan Rengi",
    border_color: "Çerçeve Rengi",
    border_size: "Çerçeve genişliği",
    border_style: "Çerçeve Stili",
    box_style: "Kutu Stili",
    opacity: "Opaklık",
    padding: "Alan",
    pos: "Konum",
    radius: "Radyan",
    source: "Kaynak",
    Answer: "Cevap",
    Number: "Sayı",
  },
};
